import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { UiKitToastApiContext } from '../../context';
import { jsx as _jsx } from "react/jsx-runtime";
var UiKitToastsInternalContextProviderComponent = function UiKitToastsInternalContextProviderComponent(props) {
  var _React$useState = React.useState({
      'bottom-center': null,
      'bottom-right': null,
      'top-center': null,
      'top-right': null
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    apiByPlacement = _React$useState2[0],
    setApi = _React$useState2[1];
  var _React$useState3 = React.useState({
      'bottom-center': '',
      'bottom-right': '',
      'top-center': '',
      'top-right': ''
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    indentByPlacement = _React$useState4[0],
    setIndent = _React$useState4[1];
  var setToastApiByPlacement = React.useCallback(function (api, placement) {
    setApi(function (currentApis) {
      return _objectSpread(_objectSpread({}, currentApis), {}, _defineProperty({}, placement, api));
    });
  }, []);
  var setIndentByPlacement = React.useCallback(function (placement, indent) {
    setIndent(function (currentIndents) {
      return _objectSpread(_objectSpread({}, currentIndents), {}, _defineProperty({}, placement, indent));
    });
  }, []);
  var contextValue = React.useMemo(function () {
    return {
      apiByPlacement: apiByPlacement,
      setToastApiByPlacement: setToastApiByPlacement,
      indentByPlacement: indentByPlacement,
      setIndentByPlacement: setIndentByPlacement
    };
  }, [apiByPlacement, setToastApiByPlacement, indentByPlacement, setIndentByPlacement]);
  return /*#__PURE__*/_jsx(UiKitToastApiContext.Provider, {
    value: contextValue,
    children: props.children
  });
};
export var UiKitToastsInternalContextProvider = /*#__PURE__*/React.memo(UiKitToastsInternalContextProviderComponent);